
import { Link } from "react-router-dom";
import "../../assets/css/pte-responsive.css";
import SkillCard from "components/Frontend/SkillCard";


const SkillAssment = (props) => {
    const { skillData } = props;
    return (

        <div className="pc-skill-areas skill-assesment">
            {/* <h2 className="pc-pte-core-title">
              The PTE Exam Covers Four Core Skills
            </h2> */}
            <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge text-white">SKILL ASSESMENT</span>
                    <br className="d-block" />
                    THE EXAM EVALUATES FOUR <br /> ESSENTIAL SKILL AREAS
                </h2>
            </div>
            <div className="skill-areas-content d-flex flex-column w-100">
                <div className="left-area d-flex gap-4 p-0 flex-wrap justify-content-center" id="skill-section">

                    {
                        skillData.map((skill) => (
                            <SkillCard key={skill.id} title={skill.title} description={skill.description} image={skill.image} bgColor={skill.color} />
                        ))
                    }
                </div>
            </div>
            <p className="text-center w-md-75 w-100 mx-auto mt-4">
                By pairing your motivation with structured preparation, you'll not only perform well but also gain the confidence needed to tackle the test format head-on. So why wait?
            </p>

            <div className="text-center">
                <Link className="primary-btn" to="/contact">
                    <span className="btn-inner">
                        START YOUR PTE JOURNEY NOW
                        <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                        />
                    </span>
                </Link>
            </div>
        </div>
    );
};

export default SkillAssment;


